import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import {
  SelectOption,
} from 'react-select-material-ui';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  FeaturedArticlesStore,
} from '../../mobx-store/stores/featuredArticlesStore';
import {
  NewsAndAnnouncementStore,
} from '../../mobx-store/stores/newsAndAnnouncementStore';
import classes from './addEditFeaturedArticles.scss';
import { FilterArticlesOptions } from '../../mobx-store/storeInterfaces/newsAndAnnouncementInterface';

interface IProps extends WithSnackbarProps {
  featuredArticlesStore: FeaturedArticlesStore;
  countryStore: CountryStore;
  newsAndAnnouncementStore: NewsAndAnnouncementStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingArticles: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
}

@inject('countryStore')
@inject('featuredArticlesStore')
@inject('newsAndAnnouncementStore')
@inject('countryStore')
@observer
class AddEditFeaturedArticles extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  featuredArticleId = -1;

  pageTitle = '';

  featuredArticleFormTitle = '';

  branchSchema: any;

  submitButton: any;

  cancelButton: any;

  lastHistory = -1;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.featuredArticleId) {
      this.isNew = false;
      this.featuredArticleId = props.match.params.featuredArticleId;
      console.log(this.featuredArticleId);
      this.pageTitle = translate('editFeaturedArticleTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addFeaturedArticleTitle', {
      });
    }
    this.initFeaturedArticleSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.featuredArticleFormTitle = 'Featured Article Info';
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getFeaturedArticle(langCode);
      this.getArticles(langCode);
    }
  };

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      this.props.newsAndAnnouncementStore.getArticles('news', 'published',
        this.props.countryStore.managedCountries, this.state.selectedLang)
        .then(() => {
          this.updateStateWithArticlesData();
        }).catch(() => {
          this.setState({
            loadingArticles: false,
          });
        });
      if (!this.isNew) {
        this.props.featuredArticlesStore.getFeaturedArticleById(this.featuredArticleId, languageCodes.english)
          .then(() => {
            this.updateStateWithFeaturedArticleData();
          }).catch(() => {
            this.setState({
              loading: false,
            });
          });
      }
    }
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  initFeaturedArticleSchema = () => {
    this.branchSchema = Yup.object().shape({
      titleEn: Yup.string()
        .nullable(true),
      articleId: Yup.object()
        .required('Required'),
      backgroundImage: Yup.array()
        .nullable(true),
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      processing: false,
      loading: !this.isNew,
      loadingManagedCountries: true,
      loadingArticles: true,
      selectedLang: languageCodes.english,
      formFields: [
        {
          name: 'title',
          label: this.isNew && this.isEgypt ? translate('featuredArticlesTableTitleArabicColumn', {
          }) : translate('featuredArticlesTableTitleColumn', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'articleId',
          label: 'Select Article',
          selectList: [],
          selectListValue: 'title',
          selectListKey: 'articleId',
          filedType: 'SearchSelectField',
        },
        {
          name: 'imageURL',
          label: 'Image',
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 200,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    values.articleId = values.articleId.value;
    this.setState({
      processing: true,
    });
    if (this.isNew) {
      this.props.featuredArticlesStore.createFeaturedArticle(values)
        .then((featuredArticleId) => {
          console.log(featuredArticleId);
          if (this.isEgypt) {
            this.props.history.push(`${featuredArticleId}/edit`);
          } else {
            this.props.history.go(this.lastHistory);
          }
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 5000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    } else {
      this.props.featuredArticlesStore.updateFeaturedArticle(this.featuredArticleId, values, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          this.props.history.go(this.lastHistory);
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    console.log('canceled');
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithArticlesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'articleId') {
        formFieldsWithData.push(
          {
            ...field,
            selectList:
                  this.props.newsAndAnnouncementStore.articlesList.map((item) => {
                    const structuredItem: SelectOption = {
                      label: item.title, value: item.articleId,
                    };
                    return structuredItem;
                  }),
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingArticles: false,
    });
  };

  updateStateWithFeaturedArticleData = () => {
    const featuredArticle = {
      ...this.props.featuredArticlesStore.selectedFeaturedArticle,
    };
    featuredArticle.articleId = {
      label: featuredArticle.article.title,
      value: featuredArticle.article.articleId,
    };
    featuredArticle.imageURL = [
      {
        imageUrl: featuredArticle.imageURL,
      },
    ];
    const formFieldsWithData: any[] = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: featuredArticle[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loading || this.state.loadingArticles || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.featuredArticleFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.branchSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    this.setState({
      loadingManagedCountries: false,
    });
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState();
    this.submitButton = this.getSubmitButton();
    this.props.newsAndAnnouncementStore.getArticles('news', 'published',
      this.props.countryStore.managedCountries,
      this.state.selectedLang)
      .then(() => {
        this.updateStateWithArticlesData();
      }).catch(() => {
        this.setState({
          loadingArticles: false,
        });
      });
    if (!this.isNew) {
      this.props.featuredArticlesStore.getFeaturedArticleById(this.featuredArticleId, this.state.selectedLang)
        .then(() => {
          this.updateStateWithFeaturedArticleData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  getFeaturedArticle = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.featuredArticlesStore.getFeaturedArticleById(this.featuredArticleId, langCode)
      .then(() => {
        this.updateStateWithFeaturedArticleData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  getArticles = (langCode: string) => {
    this.setState({
      loadingArticles: true,
    });
    const params: FilterArticlesOptions = {
      type: 'news',
      countries: this.props.countryStore.managedCountries,
      langCode,
      isExpired: false,
    };
    this.props.newsAndAnnouncementStore.filterArticles(params)
      .then(() => {
        this.updateStateWithArticlesData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loadingArticles: false,
        });
      });
  };
}

export default withRouter(AddEditFeaturedArticles);
